import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { AppFilter, CommonServices, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';

import { FinanceService } from '../../../services';
import { InvoiceDetailModal } from '../../../modals';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { InvoiceAdvancedSearchService } from '../invoice-advanced-search.service';
import { headers1 } from '../headers';
import { Subscription } from 'rxjs/internal/Subscription';
@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.scss'],
})
export class InvoiceListComponent implements OnInit, OnDestroy {
  filter: AppFilter = new AppFilter();
  baseUrl = environment.API_SERVER;
  pending: boolean;
  success: any;
  error: any;
  invoices: Array<any> = [];
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  departments: Array<any> = [];
  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'invoiceNumber',
        op: 'cn',
        data: '',
      },
      {
        field: 'title',
        op: 'cn',
        data: '',
      },
      {
        field: 'description',
        op: 'cn',
        data: '',
      },
    ],
  };
  customerNCCID: string;
  organizationId: string;
  advancedSearchSubscription!: Subscription;
  exportSearchSubscription!: Subscription;
  advancedSearchVisible = false;
  headers = headers1;
  exportFilter: AppFilter;
  exportSearchFilter: any;
  faqs;
  constructor(
    private router: Router,
    private modalService: SuiModalService,
    private financeSvc: FinanceService,
    private invoiceAdvancedSearch: InvoiceAdvancedSearchService,
    private companySvc: FinanceService,
    private commonServices: CommonServices
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    // this.customerNCCID = '000-0112';
    this.customerNCCID = JSON.parse(
      window.localStorage.getItem('organization')
    )['jpaContractor']['nccId'];
    this.filter = new AppFilter({ sidx: 'dateCreated', sord: 'desc' });
    this.filter.filters = JSON.stringify(this.searchFilter);
    // this.filter._search = false;
    this.exportFilter = new AppFilter({
      _search: true,
      sidx: 'dateCreated',
      // sidx: "actionDate",
      rows: 1000,
      sord: 'desc',
    });
    this.getPage(1, true);
    // this.payment(1);s
  }
  goBack() {}

  download(invoice) {
    this.getInvoiceDetail(invoice['invoiceNumber']);
  }

  getInvoiceDetail(invoiceNumber) {
    this.pending = true;
    this.error = null;
    this.financeSvc
      .getInvoiceDetail({ params: { invoiceNumber: invoiceNumber } })
      .subscribe(
        (res: any) => {
          let url = `${environment.API_SERVER}/finance/public/media/?media=${res['invoiceDocumentPath']}`;
          window.open(url, '_blank');
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  // get page request organization with filter params
  getPage(page: number, addToExport = false) {
    // set the page number from the caller
    this.filter.page = page;
    this.pending = true;
    this.error = null;
    this.financeSvc
      .getInvoices({
        params: { ...this.filter, ...{ customerNccId: this.customerNCCID } },
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.currentPage = this.filter.page;
          this.invoices = res['rows'];
          if (addToExport) {
            this.exportFilter.rows = this.totalItems;
          }
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getPayment(invoice) {
    this.pending = true;
    this.companySvc
      .getInvoicePayment({
        params: { invoiceNumber: invoice.invoiceNumber },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.getUnpaidInvoice(invoice, res);
        },
        (error) => {
          this.getInvoice(invoice);
        }
      );
  }
  getUnpaidInvoice(invoice, paymentDetail) {
    this.pending = true;
    this.companySvc
      .getInvoiceDetail({
        params: { invoiceNumber: invoice.invoiceNumber },
      })
      .subscribe(
        (res: any) => {
          this.directToPayment(res, paymentDetail);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getInvoice(invoice) {
    this.pending = true;
    this.companySvc
      .getInvoiceDetail({
        params: { invoiceNumber: invoice.invoiceNumber },
      })
      .subscribe(
        (res: any) => {
          this.router.navigate(
            ['/contractor/payment/pay', res.revenueServiceId],
            {
              queryParams: {
                purpose: res['categoryName'],
                amount: res['amount'],
                allowPartPayment: res['serviceAllowPartPayment'],
                revenueServiceId: res['revenueServiceId'],
                requireInvoiceNo: res['serviceReqInvoiceNo'],
                currencyCode: res['currencyCode'],
                invoiceNumber: res['invoiceNumber'],
              },
            }
          );
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  directToPayment(invoice, value) {
    if (value['paymentDetails']['invoice_number']) {
      this.router.navigate(['/contractor/payment/instruction'], {
        queryParams: {
          invoiceNumber: value['paymentDetails']['invoice_number'],
          transactionRef: value['transactionRef'],
        },
      });
    } else {
      this.router.navigate(['/contractor/payment/instruction'], {
        queryParams: {
          purpose: invoice['categoryName'],
          amount: invoice['amount'],
          allowPartPayment: invoice['serviceAllowPartPayment'],
          revenueServiceId: invoice['revenueServiceId'],
          requireInvoiceNo: invoice['serviceReqInvoiceNo'],
          currencyCode: invoice['currencyCode'],
          beneficiary: 'Nigerian Communications Commision',
          rrr: value['transactionRef'],
          paymentLink: value['paymentUrl'],
          address: value['paymentDetails']['payers_address'],
          companyName: invoice['companyName'],
          docPath: value['detailsDocumentPath'],
          description:
            value['paymentDetails']['description'] === null
              ? value['paymentDetails']['invoice_description']
              : value['paymentDetails']['description'],
          name: value['paymentDetails']['payers_name'],
          initiatedPaymentId: value['initiatedPaymentId'],
          phone: value['paymentDetails']['payers_phone'],
          email: value['paymentDetails']['payers_email'],
          paymentType: value['currencyId'] == 'naira' ? 'LOCAL' : 'FOREIGN',
          invoiceNo: value['paymentDetails']['invoice_number'],
        },
      });
    }
  }
  viewDepartment(invoice) {
    this.modalService
      .open(new InvoiceDetailModal('Invoice Detail', invoice, ModalSize.Tiny))
      .onApprove((value: any) => {
        console.log(value, 'value');
        // Check for if a simalar equipment in tamsy has been paid for
        if (value.invoiceDetails.categoryName === 'Type Approval') {
          this.checkSimilarEquipment(value, invoice);
        } else {
          if (value.paymentDetail) {
            if (value.paymentDetail['paymentDetails']['invoice_number']) {
              this.router.navigate(['/contractor/payment/instruction'], {
                queryParams: {
                  invoiceNumber:
                    value.paymentDetail['paymentDetails']['invoice_number'],
                  transactionRef: value.paymentDetail['transactionRef'],
                },
              });
            } else {
              this.router.navigate(['/contractor/payment/instruction'], {
                queryParams: {
                  purpose: invoice['categoryName'],
                  amount: invoice['amount'],
                  allowPartPayment: invoice['serviceAllowPartPayment'],
                  revenueServiceId: value['invoiceDetails']['revenueServiceId'],
                  requireInvoiceNo: invoice['serviceReqInvoiceNo'],
                  currencyCode: invoice['currencyCode'],
                  beneficiary: 'Nigerian Communications Commision',
                  rrr: value.paymentDetail['transactionRef'],
                  paymentLink: value.paymentDetail['paymentUrl'],
                  address:
                    value.paymentDetail['paymentDetails']['payers_address'],
                  companyName: invoice['companyName'],
                  docPath: value.paymentDetail['detailsDocumentPath'],
                  description:
                    value.paymentDetail['paymentDetails']['description'] ===
                    null
                      ? value.paymentDetail['paymentDetails'][
                          'invoice_description'
                        ]
                      : value.paymentDetail['paymentDetails']['description'],
                  name: value.paymentDetail['paymentDetails']['payers_name'],
                  initiatedPaymentId: value.paymentDetail['initiatedPaymentId'],
                  phone: value.paymentDetail['paymentDetails']['payers_phone'],
                  email: value.paymentDetail['paymentDetails']['payers_email'],
                  paymentType:
                    value.paymentDetail['currencyId'] == 'naira'
                      ? 'LOCAL'
                      : 'FOREIGN',
                  invoiceNo:
                    value.paymentDetail['paymentDetails']['invoice_number'],
                },
              });
            }
          } else {
            this.router.navigate(
              [
                '/contractor/payment/pay',
                value.invoiceDetails.revenueServiceId,
              ],
              {
                queryParams: {
                  purpose: invoice['categoryName'],
                  amount: invoice['amount'],
                  allowPartPayment: invoice['serviceAllowPartPayment'],
                  revenueServiceId: value['invoiceDetails']['revenueServiceId'],
                  requireInvoiceNo: invoice['serviceReqInvoiceNo'],
                  currencyCode: invoice['currencyCode'],
                  invoiceNumber: value['invoiceDetails']['invoiceNumber'],
                },
              }
            );
          }
        }
      })
      .onDeny(() => {});
  }

  checkSimilarEquipment(value, invoice) {
    console.log('here');
    this.pending = true;
    this.financeSvc
      .checkSimilarEquipment({
        invoiceNumber: value.invoiceDetails.invoiceNumber,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          if (res.data.status == true) {
            this.error = `This Invoice has a similar equipment that has already been Paid for `;
          } else {
            if (value.paymentDetail) {
              if (value.paymentDetail['paymentDetails']['invoice_number']) {
                this.router.navigate(['/contractor/payment/instruction'], {
                  queryParams: {
                    invoiceNumber:
                      value.paymentDetail['paymentDetails']['invoice_number'],
                    transactionRef: value.paymentDetail['transactionRef'],
                  },
                });
              } else {
                this.router.navigate(['/contractor/payment/instruction'], {
                  queryParams: {
                    purpose: invoice['categoryName'],
                    amount: invoice['amount'],
                    allowPartPayment: invoice['serviceAllowPartPayment'],
                    revenueServiceId:
                      value['invoiceDetails']['revenueServiceId'],
                    requireInvoiceNo: invoice['serviceReqInvoiceNo'],
                    currencyCode: invoice['currencyCode'],
                    beneficiary: 'Nigerian Communications Commision',
                    rrr: value.paymentDetail['transactionRef'],
                    paymentLink: value.paymentDetail['paymentUrl'],
                    address:
                      value.paymentDetail['paymentDetails']['payers_address'],
                    companyName: invoice['companyName'],
                    docPath: value.paymentDetail['detailsDocumentPath'],
                    description:
                      value.paymentDetail['paymentDetails']['description'] ===
                      null
                        ? value.paymentDetail['paymentDetails'][
                            'invoice_description'
                          ]
                        : value.paymentDetail['paymentDetails']['description'],
                    name: value.paymentDetail['paymentDetails']['payers_name'],
                    initiatedPaymentId:
                      value.paymentDetail['initiatedPaymentId'],
                    phone:
                      value.paymentDetail['paymentDetails']['payers_phone'],
                    email:
                      value.paymentDetail['paymentDetails']['payers_email'],
                    paymentType:
                      value.paymentDetail['currencyId'] == 'naira'
                        ? 'LOCAL'
                        : 'FOREIGN',
                    invoiceNo:
                      value.paymentDetail['paymentDetails']['invoice_number'],
                  },
                });
              }
            } else {
              this.router.navigate(
                [
                  '/contractor/payment/pay',
                  value.invoiceDetails.revenueServiceId,
                ],
                {
                  queryParams: {
                    purpose: invoice['categoryName'],
                    amount: invoice['amount'],
                    allowPartPayment: invoice['serviceAllowPartPayment'],
                    revenueServiceId:
                      value['invoiceDetails']['revenueServiceId'],
                    requireInvoiceNo: invoice['serviceReqInvoiceNo'],
                    currencyCode: invoice['currencyCode'],
                    invoiceNumber: value['invoiceDetails']['invoiceNumber'],
                  },
                }
              );
            }
          }
        },
        (error) => {
          this.pending = true;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  searchRecords(search) {
    let searchFilter = this.searchFilter;
    searchFilter.rules.forEach((rule) => {
      rule.data = search;
    });
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }
  onDisplayRecords(value) {
    this.filter.rows = value;
    this.getPage(this.filter.page);
  }

  nextPage(value) {
    this.filter.page = value;
    this.getPage(this.filter.page);
  }

  advancedSearch(event: any) {
    this.exportSearchFilter = event;
    this.filter._search = true;
    this.filter.filters = JSON.stringify(event);
    this.getPage(1, true);
  }

  downloadInvoice(media: any) {
    const filename = 'invoice.xlsx';
    const url = `${this.baseUrl}/public/media/?media=${media}&file_name=${filename}`;
    window.open(url, '_blank');
  }

  exportAdv() {
    this.pending = true;
    if (this.exportSearchFilter) {
      this.exportFilter.filters = JSON.stringify(this.exportSearchFilter);
    }
    this.invoiceAdvancedSearch
      .searchExport({
        params: { ...this.exportFilter, customerNccId: this.customerNCCID },
      })
      .subscribe(
        (res) => {
          this.downloadInvoice(res['file']);
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  ngOnInit(): void {
    this.advancedSearchSubscription =
      this.invoiceAdvancedSearch.toggleSearch.subscribe((route: string) => {
        if (route == this.invoiceAdvancedSearch.routes.list) {
          this.advancedSearchVisible = !this.advancedSearchVisible;
        }
      });

    this.exportSearchSubscription =
      this.invoiceAdvancedSearch.exportSearch.subscribe((route: string) => {
        if (route == this.invoiceAdvancedSearch.routes.list) {
          this.exportAdv();
        }
      });
  }

  ngOnDestroy(): void {
    this.advancedSearchSubscription.unsubscribe();
    this.exportSearchSubscription.unsubscribe();
  }
}
